import { ref } from 'vue'
import { defineStore } from 'pinia'
import { getVehiclesList } from '../api'

export interface IVehicle {
  make: string
  model: string,
  count: number,
  trim?: string
  trimImg?: string
}

interface IVehicleResponse {
  value: string,
  count : number
}


export const useVehiclesStore = defineStore('vehicles', () => {
  const vehicles = ref<IVehicle[]>([])
  const loading = ref(false);

  const getVehicles = async () => {
    loading.value = true;
    const vehiclesList = await getVehiclesList()
    vehiclesList.facets.make_model_sidebar.buckets.forEach((vehicle: IVehicleResponse) => {
      vehicles.value.push({
        make: vehicle.value.split('--')[0],
        model: vehicle.value.split('--')[1],
        count: vehicle.count
      })
    })
    loading.value = false
  }

  return {
    vehicles,
    loading,
    getVehicles,
  }
})
